import { render, staticRenderFns } from "./CensusUploadModal.vue?vue&type=template&id=2963247b&scoped=true"
import script from "./CensusUploadModal.vue?vue&type=script&lang=ts"
export * from "./CensusUploadModal.vue?vue&type=script&lang=ts"
import style0 from "./CensusUploadModal.vue?vue&type=style&index=0&id=2963247b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963247b",
  null
  
)

export default component.exports